import * as React from 'react';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import { ChangeEvent, FormEvent } from 'react';
import './Login.css';
import ApplicationState from '../../application/core/State';
import logo from '../img/logo/horizontal-logo.png';
import UserAuthenticationRequested from '../../application/user/events/UserAuthenticationRequested';

interface State {
    login: string;
    password: string;
}

interface StateProps {
    errorMessage: string;
}

class Login extends React.PureComponent<DispatchProps & StateProps, State> {
    constructor(props: DispatchProps & StateProps) {
        super(props);
        this.state = {
            login: '',
            password: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render(): JSX.Element {
        return (
            <div>
                <div className="login">
                    <form className="login-form" onSubmit={this.handleSubmit}>
                        <h1>Happysocks showroom</h1>
                        <label htmlFor="login">Login:</label>
                        <input name="login" onChange={this.onLoginChanged} />
                        <label htmlFor="password">Password:</label>
                        <input name="password" type="password" onChange={this.onPasswordChanged} />
                        {this.renderForgotPassword()}
                        {this.props.errorMessage && <span className="login-error-message">{this.props.errorMessage}</span>}
                        <button className="login-submit-button" onClick={this.onLoginButtonClicked}>
                            Log in
                        </button>
                    </form>
                </div>
                <div className="login-logo">
                    <img src={logo} />
                </div>
            </div>
        );
    }

    private onLoginChanged = (event: ChangeEvent<HTMLInputElement>): void =>
        this.setState({
            login: event.currentTarget.value
        });

    private onPasswordChanged = (event: ChangeEvent<HTMLInputElement>): void =>
        this.setState({
            password: event.currentTarget.value
        });

    private onLoginButtonClicked = (): void => {
        this.props.dispatch(new UserAuthenticationRequested(this.state.login, this.state.password));
    };

    private handleSubmit = (event: FormEvent): void => {
        event.preventDefault();
        this.onLoginButtonClicked();
    };

    private renderForgotPassword = (): null => {
        // todo implement on backend
        return null;
        // <button className="login-forgot-button link-button"><NavLink to="/forgot-password">Forgot password?</NavLink></button>
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    errorMessage: state.user.errorMessage
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/view/login/Login.tsx